<template>
  <ec-dialog :dialog.sync="visible">
    <template v-slot:title>{{$t('FilterBillingDeals')}}</template>
    <template v-slot:right>
      <v-btn color="primary" class="my-2" @click="apply()" :disabled="!formIsValid">{{$t('Apply')}}</v-btn>
    </template>
    <template>
      <div class="d-flex px-4 py-2 justify-end">
        <v-btn color="primary"
          :block="$vuetify.breakpoint.smAndDown"
          outlined
          @click="resetFilter">{{ $t("Reset") }}
        </v-btn>
      </div>
      <div class="px-4 py-2">
        <v-form ref="form" v-model="formIsValid" :key="key">
          <v-row>
            <v-col cols="12" md="12" class="pb-2 pt-0">
              <customer-dialog-invoker
                :key="model.consumerID"
                :terminal="model.terminalID"
                :customer-id="model.consumerID"
                @update="processCustomer($event)"></customer-dialog-invoker>
            </v-col>
            <!-- <v-col cols="4" md="3">
              <v-switch v-model="model.invoiceOnly">
                <template v-slot:label>
                  <small>{{ $t('InvoiceOnly') }}</small>
                </template>
              </v-switch>
            </v-col>
            <v-col cols="4" md="3">
              <v-switch
                v-model="model.showDeleted"
                true-value="1"
                false-value="0"
              >
                <template v-slot:label>
                  <small>{{ $t('Inactive') }}</small>
                </template>
              </v-switch>
            </v-col>
            <v-col cols="4" md="3">
              <v-switch v-model="model.paused">
                <template v-slot:label>
                  <small>{{ $t('Paused') }}</small>
                </template>
              </v-switch>
            </v-col>
            <v-col cols="4" md="3">
              <v-switch v-model="model.finished">
                <template v-slot:label>
                  <small>{{ $t('Finished') }}</small>
                </template>
              </v-switch>
            </v-col>
            <v-col cols="4" md="3">
              <v-switch v-model="model.hasError">
                <template v-slot:label>
                  <small>{{ $t('HasError') }}</small>
                </template>
              </v-switch>
            </v-col>
            <v-col cols="4" md="3">
              <v-switch v-model="model.inProgress">
                <template v-slot:label>
                  <small>{{ $t('InProgress') }}</small>
                </template>
              </v-switch>
            </v-col>
            <v-col cols="4" md="3">
              <v-switch v-model="model.creditCardExpired">
                <template v-slot:label>
                  <small>{{ $t('CreditCardExpired') }}</small>
                </template>
              </v-switch>
            </v-col> -->
          </v-row>
          <v-row>
            <!-- <v-col cols="12" md="12" class="py-0">
              <v-switch
                v-model="model.finished"
                :label="$t('Finished')"
              ></v-switch>
            </v-col> -->
            <v-col cols="6" md="6" class="py-0">
              <v-text-field
                v-model="model.billingDealID"
                :label="$t('BillingDealID')"
                :rules="[vr.primitives.guid]"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="6" class="py-0">
              <terminal-select v-model="model.terminalID" clearable show-deleted></terminal-select>
            </v-col>
            <!-- <v-col cols="12" md="6" class="py-0">
              <v-select
                :items="availableCurrencies"
                item-text="description"
                item-value="code"
                v-model="model.currency"
                :label="$t('Currency')"
                outlined
                clearable
              ></v-select>
            </v-col> -->
          </v-row>
          <v-row>
            <!-- <v-col cols="12" md="6" class="py-0">
              <v-text-field
                v-model="model.cardOwnerNationalID"
                :label="$t('CardOwnerNationalID')"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                v-model="model.cardOwnerName"
                :label="$t('CardOwnerName')"
                outlined
              ></v-text-field>
            </v-col> -->
            <!-- <v-col cols="12" md="12" class="py-0">
              <v-text-field
                v-model="model.consumerEmail"
                :label="$t('CustomerEmail')"
                outlined
              ></v-text-field>
            </v-col> -->
            <date-from-to-filter class="px-3" v-model="model" from-today @change="resetValidation"></date-from-to-filter>
          </v-row>
        </v-form>
      </div>
    </template>
  </ec-dialog>
</template>

<script>
import FilterMixin from "@/extensions/mixins/FilterMixin";
import moment from "moment";

export default {
  components: {
    EcRadioGroup: () => import("../../components/inputs/EcRadioGroup"),
    EcDialog: () => import("../../components/ec/EcDialog"),
    DateFromToFilter: () => import("../filtering/DateFromToFilter"),
    CustomerDialogInvoker: () => import("../../components/dialog-invokers/CustomerDialogInvoker"),
  },
  mixins: [FilterMixin],
  data() {
    return {
      model: {
        ...this.filter,
        dateFrom: moment().add(1, 'months').startOf('month').toISOString(),
        dateTo: moment().add(1, 'months').endOf('month').toISOString(),
      },
    };
  },
};
</script>

<style lang="scss" scoped>
</style>